const UnknownStep = () => <span>Unknown step</span>;

const StepContent = ({ step, steps, StepContent, ...props }) => {
  const StepComponent = steps[step]?.StepComponent || UnknownStep;
  return <StepComponent {...props} />;
};

export default StepContent;
